import type { IconProps } from '@/types/general'

export const LinkedIn = (props: IconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="17"
		height="18"
		viewBox="0 0 17 18"
		fill="currentColor"
		className={props.className}
	>
		<g clipPath="url(#clip0_8_4721)">
			<path
				d="M15.81 0.502808H1.19C0.874392 0.502808 0.571711 0.628182 0.348543 0.851351C0.125375 1.07452 0 1.3772 0 1.69281L0 16.3128C0 16.6284 0.125375 16.9311 0.348543 17.1543C0.571711 17.3774 0.874392 17.5028 1.19 17.5028H15.81C16.1256 17.5028 16.4283 17.3774 16.6515 17.1543C16.8746 16.9311 17 16.6284 17 16.3128V1.69281C17 1.3772 16.8746 1.07452 16.6515 0.851351C16.4283 0.628182 16.1256 0.502808 15.81 0.502808ZM5.05 15.0428H2.55V6.94281H5.05V15.0428ZM3.79 5.88281C3.49208 5.88677 3.19974 5.80193 2.95023 5.63909C2.70072 5.47626 2.50536 5.24281 2.38905 4.9685C2.27274 4.6942 2.24075 4.39147 2.29717 4.09892C2.35358 3.80637 2.49584 3.53724 2.70581 3.32586C2.91577 3.11447 3.18393 2.9704 3.4761 2.91202C3.76827 2.85364 4.0712 2.88359 4.34628 2.99804C4.62136 3.1125 4.85612 3.30629 5.02064 3.5547C5.18515 3.8031 5.27196 4.09487 5.27 4.39281C5.27001 4.78625 5.1144 5.16373 4.83713 5.44288C4.55986 5.72202 4.18344 5.88017 3.79 5.88281ZM14.44 15.0428H12V10.7928C12 9.62281 11.56 8.97281 10.63 8.97281C9.7 8.97281 9.11 9.65281 9.11 10.7928V15.0428H6.65V6.94281H9.06V8.03281C9.31603 7.61745 9.67545 7.27562 10.1031 7.04075C10.5308 6.80587 11.0121 6.68599 11.5 6.69281C13.21 6.69281 14.44 7.69281 14.44 9.91281V15.0428Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			{/* biome-ignore lint/correctness/useUniqueElementIds: SVG clipPath ID is scoped to this component */}
			<clipPath id="clip0_8_4721">
				<rect width="17" height="17" fill="white" transform="translate(0 0.502808)" />
			</clipPath>
		</defs>
	</svg>
)
